import type { TenantPublicSettings } from '@/common/api/models/tenantPublicSettings';

export const playgroundTenantSettings = {
  gradingSettings: {
    evalDimensions: {
      formal: {
        description: 'Formal requirements and academic conventions.',
        maxWeight: 0.2,
      },
      description: {
        description: 'Clear explanation of concepts and theories.',
        maxWeight: 0.3,
      },
      analysis: {
        description: 'Critical evaluation and analytical depth.',
        maxWeight: 0.3,
      },
      application: {
        description: 'Practical application of theories.',
        maxWeight: 0.2,
      },
    },
    performanceLevels: [
      {
        id: 'very_good',
        performancePercent: 1,
        label: 'Very Good',
        description: 'Excellent performance',
      },
      {
        id: 'good',
        performancePercent: 0.8,
        label: 'Good',
        description: 'Strong performance',
      },
      {
        id: 'satisfactory',
        performancePercent: 0.6,
        label: 'Satisfactory',
        description: 'Acceptable performance',
      },
      {
        id: 'needs_improvement',
        performancePercent: 0.3,
        label: 'Needs Improvement',
        description: 'Below expectations',
      },
      {
        id: 'n/a',
        performancePercent: 0,
        label: 'n/a',
        description: 'Not applicable',
      },
    ],
    oralExamDimensionKeys: [
      'content',
      'depth',
      'application',
      'communication',
      'professionalism',
    ],
  },
  processSettings: {
    legacyCourseCompatibilityMode: false,
  },
  eventKinds: {
    oral_exam_20: {
      id: 'oral_exam_20',
      label: 'Oral Exam',
      kind: 'oral_exam',
      durationMin: 20,
      maxCapacity: 1,
      planning: {
        horizonMo: 3,
        freq: 'weekly',
        interval: 1,
      },
      requiresEvaluation: true,
    },
  },
} as unknown as TenantPublicSettings;
